import { render, staticRenderFns } from "./fee-schedule.vue?vue&type=template&id=3c4dd7f6&scoped=true&"
import script from "./fee-schedule.vue?vue&type=script&lang=js&"
export * from "./fee-schedule.vue?vue&type=script&lang=js&"
import style0 from "./fee-schedule.vue?vue&type=style&index=0&id=3c4dd7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4dd7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4dd7f6')) {
      api.createRecord('3c4dd7f6', component.options)
    } else {
      api.reload('3c4dd7f6', component.options)
    }
    module.hot.accept("./fee-schedule.vue?vue&type=template&id=3c4dd7f6&scoped=true&", function () {
      api.rerender('3c4dd7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/fee-schedule.vue"
export default component.exports